import styled from "styled-components";

export const ContainerFirmaOrdenDigital = styled.div`
  padding: 0 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
